import currency from '../helpers/currency';

class LineItemTable {
  init() {
    document.addEventListener('quantity:change', this.handleQuantityChange.bind(this));
  }

  handleQuantityChange(event:CustomEvent) {
    document.querySelectorAll(`[data-line-item-total-price="${ event.detail.key }"]`).forEach((lineItemTotalPrice:HTMLElement) => {
      this.updateLineItemTotalPrice(lineItemTotalPrice, event)
    });
  }

  updateLineItemTotalPrice(lineItemTotalPrice:HTMLElement, event:CustomEvent) {
    lineItemTotalPrice.innerText = currency.format(event.detail.price * event.detail.quantity);
    this.updateSubtotal();
  }

  updateSubtotal() {
    const subtotal:HTMLElement = document.querySelector('[data-subtotal-price]');
    subtotal.innerText = currency.format(this.calcSubtotal());
  }

  calcSubtotal() {
    return Array.from(document.querySelectorAll('[data-line-item-total-price]')).reduce((accumulator:number, lineItemTotalPrice:HTMLElement) => {
      const lineItemTotalPriceValue = currency.parseFromStringToPrice(lineItemTotalPrice.innerText);
      accumulator += lineItemTotalPriceValue;
      return accumulator;
    }, 0);
  }
}

export default new LineItemTable();